import type { NewsletterPlacement } from '../../services/newsletter'

const primarySignupRoutes = new Set([
  '/', '/launch', '/x-launch',
])

export function shouldRenderNewsletterPlacement(placement: NewsletterPlacement, pathname: string): boolean {
  if (placement !== 'footer') return true
  const normalized = pathname.length > 1 ? pathname.replace(/\/+$/, '') : '/'
  return !primarySignupRoutes.has(normalized) && !normalized.startsWith('/article/')
}
